import React, {useEffect, useState } from "react";
import { getAllDocuments, getOrganizations, addDocument} from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { alertError, alertSuccess } from "../../utils/alerts";


const INIT_STATE = {
    organization: "",
    document_name: "",
    document_file: "",
    document_desc:"",
};

export default function OutsourcingOnboarding() {
    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState(null);
    const [orgs, setOrgs] = useState(null);
    const [state, setState] = useState(INIT_STATE);
    const [document_file, setDocumentFile] = useState("");

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setLoading(true);
        getAllDocuments()
            .then((res) => { 
                setDocuments(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getOrganizations()
            .then((res) => { 
                setOrgs(res.data.data);  
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    useEffect(() => {
        if(document_file){
            setState((prev) => ({
                ...prev,
                document_file: document_file,
            }));
        }
    }, [document_file]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        setLoading(true);
        addDocument(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
    };

    return (
        <>
            {documents && documents.length > 0 ? 
                <div className="spur-card-menu">
                    <Link to="/outsourcing/onboard" className="pull-right btn topbtn btn-primary">ONBOARD EMPLOYEES</Link>
                </div>
            : null}

            <h1 className="dash-title">Outsourcing</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Onboarding Documents</div>
                            <div className="spur-card-menu">
                                <button data-toggle="modal" style={{backgroundColor:"#fcce0d", color:"#444", border:'1px solid #fcce0d', fontWeight:'bold'}} 
                                    data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">UPLOAD</button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && documents && documents) ? 
                                    <div className="table-responsive">
                                        {(documents && documents.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Organization</th><th>Name/Title</th>
                                                <th>Description</th><th>Document</th></tr>
                                            </thead>
                                            <tbody>
                                                {documents && documents.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.organization?.name && row?.organization?.name}</td>
                                                        <td>{row?.document_name && row?.document_name} </td>
                                                        <td>{(row?.document_desc && row?.document_desc) || "Nil"}</td>
                                                        <td>
                                                            <a href={(row?.document_url && row?.document_url) || "Nil"} 
                                                                target="_blank" rel="noreferrer" className='btn btn-preview'
                                                            >
                                                                <i className="fa fa-eye"></i> View Document
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPLOAD ONBOARDING DOCUMENT</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Organization <span>*</span></label>
                                    <select className="form-control form-select" name="organization" id="organization" required  
                                    onChange={handleChange} defaultValue={state.organization} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {orgs && orgs.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name/Title of Document <span>*</span></label>
                                    <input type="text" name="document_name" className="form-control" required placeholder="Name/Title of Document" 
                                     onChange={handleChange} defaultValue={state.document_name && state.document_name }  disabled={loading} />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Document <span>*</span></label>
                                    <input type="file" name="document_file" className="form-control" required placeholder="Document" disabled={loading}
                                        onChange={(e) => {setDocumentFile(e.target.files[0]);}} 
                                    />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Short Description of Document <span>*</span></label>
                                    <textarea cols="33" rows="3" name="document_desc" className="form-control" required 
                                        placeholder="Short Description of Document" maxLength={200}
                                         onChange={handleChange} defaultValue={state.document_desc && state.document_desc}  disabled={loading}></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Upload Document</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
